import { useRef, useEffect } from "@/common/hooks";
import { Modal } from "bootstrap";
import { Heading, Button } from "@/common/components";
import { isValidElement } from "react";

const InfoPopup = ({
  showModal,
  body = "",
  primaryButtonText = "",
  primaryButtonClassName = "",
  secondaryButtonText = "",
  secondaryButtonClassName = "",
  primaryButtonClick,
  secondaryButtonClick,
  heading = "",
  primaryButtonDisabled = false,
  onHideModal = () => {},
}) => {
  const modalRef = useRef();

  useEffect(() => {
    if (showModal) {
      showModalFunction();
    }
  }, [showModal]);

  const showModalFunction = () => {
    const modalEle = modalRef.current;
    const bsModal = new Modal(modalEle, {
      backdrop: "static",
      keyboard: false,
    });
    bsModal.show();
  };

  const hideModal = () => {
    const modalEle = modalRef.current;
    const bsModal = Modal.getInstance(modalEle);
    bsModal.hide();
  };

  const primaryClick = () => {
    hideModal();
    primaryButtonClick();
  };

  const secondaryClick = () => {
    hideModal();
    secondaryButtonClick();
  };

  useEffect(() => {
    if (onHideModal) {
      onHideModal(hideModal);
    }
  }, []);

  return (
    <div className="infoPopup">
      <div className="modal fade" ref={modalRef} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content py-3">
            <div className="modal-body text-center pt-4">
              {heading && <Heading text={heading} wrapperClassNames="h4" />}
              {isValidElement(body) ? (
                body
              ) : (
                <div dangerouslySetInnerHTML={{ __html: body }}></div>
              )}
            </div>
            <div className="modal-footer justify-content-center border-top-0 d-flex">
              <Button
                type="primary"
                text={primaryButtonText}
                wrapperClassName={`col-12 col-md-5 ${primaryButtonClassName}`}
                click={() => primaryClick()}
                ariaLabel={primaryButtonText}
                disabled={primaryButtonDisabled}
              />

              {secondaryButtonText && (
                <Button
                  type="secondary"
                  text={secondaryButtonText}
                  wrapperClassName={`col-12 col-md-5 ${secondaryButtonClassName}`}
                  click={() => secondaryClick()}
                  ariaLabel={secondaryButtonText}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPopup;
